import { services as servicesExercise } from '../services/exercise';
import { services as servicesRelax } from '../services/relax';
import type { NavbarItem } from './link';

export const items: NavbarItem[] = [
  {
    label: 'Relax & energie',
    link: '/relax',
    dropdown: { type: 'relax', services: servicesRelax },
  },
  {
    label: 'Trénink & Adrenalin',
    link: '/trenink',
    dropdown: { type: 'exercise', services: servicesExercise },
  },
  // { label: 'Dárkové poukazy', link: '/poukazy' },
  { label: 'Kontakt', link: '#kontakt' },
];

export function expandLinks(_items: NavbarItem[]) {
  return _items.flatMap((i) =>
    i.dropdown
      ? [
          ...i.dropdown.services.map<NavbarItem>((s) => ({
            link: s.url,
            label: s.title,
          })),
        ]
      : [i],
  );
}
